
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { DisenioVehiculos } from '../../layout';
import { useSubirAndVerImg, useVehiculosXID } from '../../../hooks';
import { BackdropScreen, CardsDeImagenes, ModalVerImagen } from '../../components';



export const ImagesSeguros = () => {


    const { id } = useParams();
    const { data } = useVehiculosXID(`${id}`);
    const { imagen, carpeta, fileInputRef, cargando, handleAction, handleFileChange, handleVerImagen, handleDescargar } = useSubirAndVerImg();



    const documentos = [
        {id:'1', titulo:'Imagen Soat', tipo:'vehiculo', image:data?.imgSoat, carpeta:'soat', campo:'imgSoat' },
        {id:'2', titulo:'Tecno Mecanica', tipo:'vehiculo', image:data?.imgTecno, carpeta:'tecno', campo:'imgTecno'},
        {id:'3', titulo:'Tarjeta Propiedad', tipo:'vehiculo', image:data?.imgPropiedad, carpeta:'tpropiedad', campo:'imgPropiedad'},
        {id:'4', titulo:'Todo Riesgo', tipo:'vehiculo', image:data?.imgTodoRiesgo, carpeta:'todoriesgo', campo:'imgTodoRiesgo'},
        // ...(usuario?.permisosExtra.includes('carnets')
        // ? [{ id: '4', titulo: 'Carnet de Afiliación', tipo:'clubes', image:imagenes?.carnet, carpeta:'carnet', campo:'carnet' }]
        // : [])
    ];




    return (

        <DisenioVehiculos titulo='Imagenes de Vehiculo' url='/admin/list-vehiculo'>
            <BackdropScreen titulo="Generando tu solicitud por favor espere..." cargando={cargando} />

            <Grid container spacing={3} sx={{display:'flex', justifyContent:{xs:'center', sm:'flex-start'}, alignItems:'center'}}>
                {documentos.map((item) => (
                    <CardsDeImagenes
                        key={item.id} 
                        item={item} 
                        funtion1={handleAction} 
                        funtion2={handleVerImagen} 
                        funtion3={handleDescargar} 
                    />
                ))}
            </Grid>

            {/* Mostrar para subir imagen */}
            <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange}/>

            {/* Ver imagen elegida */}
            <ModalVerImagen img={imagen} carpeta={carpeta} />
        </DisenioVehiculos>
    )
}